/**
 * @name piano
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTN2NCIgLz4KICA8cGF0aCBkPSJNMTQgMTN2NCIgLz4KICA8cGF0aCBkPSJNMTggMTN2NCIgLz4KICA8cGF0aCBkPSJNMiAxM2gyMCIgLz4KICA8cGF0aCBkPSJNMjIgMTEuNUEzLjUgMy41IDAgMDAxOC41IDhhMy41MiAzLjUyIDAgMDEtMy4xNzMtMkE3IDcgMCAwMDIgOXYxMGEyIDIgMCAwMDIgMmgxNmEyIDIgMCAwMDItMnoiIC8+CiAgPHBhdGggZD0iTTYgMTN2NCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/piano
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Piano: string = `
<svg
  class="lucide lucide-piano"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 13v4" />
  <path d="M14 13v4" />
  <path d="M18 13v4" />
  <path d="M2 13h20" />
  <path d="M22 11.5A3.5 3.5 0 0018.5 8a3.52 3.52 0 01-3.173-2A7 7 0 002 9v10a2 2 0 002 2h16a2 2 0 002-2z" />
  <path d="M6 13v4" />
</svg>
`;

export default Piano;
